import { FC } from 'react'

import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import styled from 'styled-components'

import { PrimaryInput } from 'src/Components/PrimaryInput'
import { CTAButton } from 'src/Components/Buttons/CTAButton'

import { ResetPasswordSchema } from './helpers'

import { Container, Form } from './styles'

const StyledButton = styled(CTAButton)`
  margin: 0 auto;
`

interface FormState {
  password: string
  confirm: string
}

interface ResetPasswordFormProps {
  onSubmit: (data: FormState) => void
}

const ResetPasswordForm: FC<ResetPasswordFormProps> = ({ onSubmit }) => {
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<FormState>({
    resolver: yupResolver(ResetPasswordSchema),
    defaultValues: { password: '', confirm: '' },
  })

  return (
    <Form onSubmit={handleSubmit((data) => onSubmit(data))}>
      <Container>
        <Controller
          name='password'
          control={control}
          render={({ field: { onChange, value, name } }) => (
            <PrimaryInput
              name={name}
              value={value}
              onChange={onChange}
              placeholder='Choose a new password'
              error={errors.password?.message}
              type='password'
            />
          )}
        />
      </Container>
      <Container>
        <Controller
          name='confirm'
          control={control}
          render={({ field: { onChange, value, name } }) => (
            <PrimaryInput
              name={name}
              value={value}
              onChange={onChange}
              placeholder='Confirm your new password'
              error={errors.confirm?.message}
              type='password'
            />
          )}
        />
      </Container>
      <StyledButton type='submit'>Change password</StyledButton>
    </Form>
  )
}

export default ResetPasswordForm
